export const SET_FOCUSED = 'SET_FOCUSED';